import qs from "qs";

export class SubscriberClient {
  constructor(httpClient, baseURL) {
    this.httpClient = httpClient;
    this.baseURL = `${baseURL}/subscribers`;
  }

  async list(params) {
    const queryString = qs.stringify(params, {
      addQueryPrefix: true
    });
    const url = `${this.baseURL}${queryString}`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async get(id) {
    const url = `${this.baseURL}/${id}`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async getPaymentStatus(id) {
    const url = `${this.baseURL}/${id}/payment_status`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async getAppointments(id) {
    const url = `${this.baseURL}/${id}/appointments`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async post(params) {
    const url = this.baseURL;

    const response = await this.httpClient.request("post", url, {
      data: params
    });

    return response;
  }

  async postFreeTrialAdd(params) {
    const url = `${this.baseURL}/free_trial/add`;

    const response = await this.httpClient.request("post", url, {
      data: params
    });

    return response;
  }

  async put(id, params) {
    const url = `${this.baseURL}/${id}`;

    const response = await this.httpClient.request("put", url, {
      data: params
    });

    return response;
  }

  async delete(id) {
    const url = `${this.baseURL}/${id}`;

    const response = await this.httpClient.request("delete", url);

    return response;
  }

  async postCancel(id, options = {}) {
    const url = `${this.baseURL}/cancel`;
    const data = {
      subscriptionId: id,
      ...options
    };

    const response = await this.httpClient.request("post", url, {
      data
    });

    return response;
  }

  async postUnsubscribe(id) {
    const url = `${this.baseURL}/unsubscribe`;
    const data = { subscriptionId: id };

    const response = await this.httpClient.request("post", url, {
      data
    });

    return response;
  }

  async getPackageRegistrationForms(id, params) {
    const query = qs.stringify(params, { addQueryPrefix: true });
    const url = `${this.baseURL}/packages/${id}/registration_forms${query}`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async getPackageRegistrationFormsPdfsZip(id, params) {
    const query = qs.stringify(params, { addQueryPrefix: true });
    const url = `${this.baseURL}/packages/${id}/registration_forms/pdfs/zip${query}`;

    const response = await this.httpClient.request("get", url, {
      responseType: "blob"
    });

    return response;
  }

  async postRevokeUnsubsribe(id) {
    const url = `${this.baseURL}/revoke_unsubscribe`;
    const data = { subscriptionId: id };

    const response = await this.httpClient.request("post", url, {
      data
    });

    return response;
  }

  async postRefund(id) {
    const url = `${this.baseURL}/expired/cancel`;
    const data = { history_id: id };

    const response = await this.httpClient.request("post", url, {
      data
    });

    return response;
  }

  async getReport(params) {
    const query = qs.stringify(params, { addQueryPrefix: true });
    const url = `${this.baseURL}/status/report${query}`;

    const response = await this.httpClient.request("get", url, {
      responseType: "blob"
    });

    return response;
  }

  async getUserTaxInvoices(userId) {
    const url = `${this.baseURL}/tax_invoices/user/${userId}`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async postGenerateUserTaxInvoice(params) {
    const url = `${this.baseURL}/tax_invoices/generate`;

    const response = await this.httpClient.request("post", url, {
      params
    });

    return response;
  }

  async postAddUserTaxInvoice(params) {
    const url = `${this.baseURL}/tax_invoices`;

    const response = await this.httpClient.request("post", url, {
      data: params
    });

    return response;
  }

  async putUpdateUserTaxInvoices(params) {
    const url = `${this.baseURL}/tax_invoices/${params.taxInvoiceId}`;

    const response = await this.httpClient.request("put", url, {
      data: params
    });

    return response;
  }

  async deleteUserTaxInvoices(params) {
    const url = `${this.baseURL}/tax_invoices/${params.taxInvoiceId}`;

    const response = await this.httpClient.request("delete", url, {
      data: params
    });

    return response;
  }

  async putDefaultUserTaxInvoices(params) {
    const url = `${this.baseURL}/tax_invoices/default/${params.taxInvoiceId}`;

    const response = await this.httpClient.request("put", url, {
      params
    });

    return response;
  }

  async postOfflinePurchase(params) {
    const url = `${this.baseURL}/package/add`;

    const response = await this.httpClient.request("post", url, {
      data: params
    });

    return response;
  }

  async getPackRakPobReport() {
    const url = `${this.baseURL}/packrakpob/report`;

    const response = await this.httpClient.request("get", url, {
      responseType: "blob"
    });

    return response;
  }

  async putMaintenanceRequest(id, param) {
    const url = `${this.baseURL}/maintenance_request/${id}`;

    const response = await this.httpClient.request("put", url, {
      data: param
    });

    return response;
  }

  async putTaxInvoiceToCurrentInvoice(params) {
    const url = `${this.baseURL}/tax_invoices/invoice/${params.invoiceId}`;

    const response = await this.httpClient.request("put", url, {
      params
    });

    return response;
  }

  async putInvoiceToCancelUserTaxInvoice(invoiceId) {
    const url = `${this.baseURL}/tax_invoices/invoice/${invoiceId}/cancel`;

    const response = await this.httpClient.request("put", url);

    return response;
  }

  async getBankInformationList() {
    const url = `${this.baseURL}/banks/transfer`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async putRefundRemarkRequest(id, param) {
    const url = `${this.baseURL}/refund_remark/${id}`;

    const response = await this.httpClient.request("put", url, {
      data: param
    });

    return response;
  }
}
